// extracted by mini-css-extract-plugin
export default {"carrosselContainer":"Roleta_carrosselContainer__R5Tm-","carrossel":"Roleta_carrossel__1IdYa","rolar":"Roleta_rolar__Hssuv","logo":"Roleta_logo__v4UHU"};